import { VpnKeyOutlined } from '@mui/icons-material'
import { Button, ButtonProps, Tooltip } from '@mui/material'
import { FunctionComponent, useState } from 'react'

import { useUtils } from '../../../../../base/hooks/useUtils.tsx'
import { UseIsiPrintResult } from '../../hooks/useIsiPrint.ts'
import { mensajeIsiPrint } from '../../services/isiPrintClient.ts'

interface Props extends Omit<ButtonProps, 'onClick'> {
  isi: UseIsiPrintResult
  texto?: string
}

/**
 * Pide un token nuevo al backend y lo entrega a isi-print, aunque el actual siga vigente.
 * Aplica los dominios agregados a ISI_PRINT_ORIGINS o una licencia renovada, sin el diálogo del cajero.
 * Solo se muestra si isi-print responde y el comercio tiene licencia de impresión.
 */
const IsiPrintLicenciaButton: FunctionComponent<Props> = ({
  isi,
  texto = 'Actualizar licencia',
  ...props
}) => {
  const { toast } = useUtils()
  const [renovando, setRenovando] = useState(false)

  if (!isi.licenciaProductoActiva || ['VERIFICANDO', 'NO_INSTALADO', 'NO_SOPORTADO'].includes(isi.estado))
    return null

  return (
    <Tooltip title="Vuelve a entregar la licencia a isi-print (aplica dominios nuevos o una renovación)">
      <Button
        size="small"
        startIcon={<VpnKeyOutlined />}
        loading={renovando}
        {...props}
        onClick={async () => {
          setRenovando(true)
          try {
            const lic = await isi.renovarLicencia()
            if (lic.valid) {
              const vence = lic.expires_at ? new Date(lic.expires_at).toLocaleDateString('es-BO') : null
              toast.success(`Licencia de isi-print actualizada${vence ? ` · vigente hasta ${vence}` : ''}`)
            } else {
              toast.warning(lic.message || 'isi-print no aceptó la licencia')
            }
          } catch (e) {
            toast.error(mensajeIsiPrint(e))
          } finally {
            setRenovando(false)
          }
        }}
      >
        {texto}
      </Button>
    </Tooltip>
  )
}

export default IsiPrintLicenciaButton
